<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة  تقرير مفصل فرع  من الي
        <br />
        {{ $route.query.name }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          تقرير  مفصل فرع  لـ {{ $route.query.name }} من الي
          {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-8">
            <div style="float:right;font-size:17px;text-align:right">
             <p>
                <span style="font-weight:bold;">مجموع المبيعات  : </span>
                <span> {{ fatworas_sum }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> مجموع المرتجعات : </span>
                <span> {{ fatworas2_sum }} </span>
              </p>
        
              <p>
                <span style="font-weight:bold;"> مجموع المشتريات: </span>
                <span> {{ fatworas3_sum }} </span>
              </p>
             <p>
                <span style="font-weight:bold;">مجموع مرتجع المشتريات : </span>
                <span> {{ fatworas4_sum }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> مجموع المصروفات: </span>
                <span> {{ fatworas5_sum }} </span>
              </p>
        
              <p>
                <span style="font-weight:bold;"> مجموع السدادات: </span>
                <span> {{ fatworas6_sum }} </span>
              </p>
             <p>
                <span style="font-weight:bold;">مجموع الخصومات : </span>
                <span> {{ fatworas7_sum }} </span>
              </p>
            
        
            </div>
          </div>
   
        </div>
        <hr />
        <p>المبيعات</p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">اسم العميل</th>
              <th scope="col">كود الفاتورة</th>
              <th scope="col">الخصم</th>
              <th scope="col">قبل الخصم</th>
              <th scope="col">بعد الخصم</th>
              <th scope="col">التاريخ</th>
              <th scope="col">التسليم</th>
              <th scope="col">اسم المخزن</th>
              <th scope="col">الحالة</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <th scope="row">{{ f.client ? f.client.name : '' }}</th>
              <td>{{ f.code }}</td>
              <td>{{ f.discount }}</td>
              <td>{{ f.price_before }}</td>
              <td>{{ f.price_after }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
              <td>{{ f.taslim_date }}</td>
              <td>{{ f.store ? f.store.name : '' }}</td>
              <td>{{ f.sdad_status }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>مرتجعات المبيعات</p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas2.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">اسم العميل</th>
              <th scope="col">كود المرتجع</th>
              <th scope="col">الخصم المرتجع</th>
              <th scope="col">قبل الخصم</th>
              <th scope="col">بعد الخصم</th>
              <th scope="col">التاريخ </th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas2" :key="f.id">
               <th scope="row">{{ f.client ? f.client.name : '' }}</th>
              <td>{{ f.code }}</td>
              <td>{{ f.reback_discount }}</td>
              <td>{{ f.price_before }}</td>
              <td>{{ f.price_after }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>المشتربات </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas3.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">اسم المورد</th>
              <th scope="col">كود الفاتورة</th>
              <th scope="col">الكود الورقي</th>
              <th scope="col">السعر</th>
              <th scope="col">الخصم</th>
              <th scope="col">السعر النهائي</th>
              <th scope="col">اسم المخزن</th>
              <th scope="col">التاريخ</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas3" :key="f.id">
              <th scope="row">{{ f.importer ? f.importer.name : '' }}</th>
              <td>{{ f.code }}</td>
              <td>{{ f.paper_code }}</td>
              <td>{{ f.price }}</td>
              <td>{{ f.fatwora_dicount }}</td>
              <td>{{ f.final_price }}</td>
              <td>{{ f.store ? f.store.name :  '' }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>مرتجعات المشتربات </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas4.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">اسم المورد</th>
              <th scope="col">كود الفاتورة</th>
              <th scope="col">السعر</th>
              <th scope="col">الخصم المرتجع</th>
              <th scope="col">السعر النهائي</th>
              <th scope="col">التاريخ</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas4" :key="f.id">
              <th scope="row">{{ f.importer ? f.importer.name : '' }}</th>
              <td>{{ f.code }}</td>
              <td>{{ f.price }}</td>
              <td>{{ f.fatwora_dicount_back }}</td>
              <td>{{ f.final_price }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>المصروفات </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas5.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود</th>
              <th scope="col">المصروف</th>
              <th scope="col">نوع المصروف</th>
              <th scope="col">الشخص المسئول</th>
              <th scope="col">تم الصرف لمن؟</th>
              <th scope="col">ملاحظات</th>
              <th scope="col">التاريخ</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas5" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.money_q }}</td>
              <td>{{ f.money.name }}</td>
              <td>{{ f.emp_responsible_name }}</td>
              <td>{{ f.emp_name_to }}</td>
              <td>{{ f.notes }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>سداد العملاء </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas6.length > 0"
        >
             <thead>
            <tr>
              <th scope="col">اسم العميل</th>
              <th scope="col">المبلغ</th>
              <th scope="col">الملاحظات </th>
              <th scope="col">مندوب التحصيل </th>
              <th scope="col"> التاريخ</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas6" :key="f.id">
              <th scope="row">{{ f.client ? f.client.name : '' }}</th>
              <td>{{ f.money_q }}</td>
              <td>{{ f.note }}</td>
              <td>{{ f.mandob_tahsil ? f.mandob_tahsil.name : '' }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>خصومات العملاء </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas7.length > 0"
        >
        <thead>
            <tr>
              <th scope="col">اسم العميل</th>
              <th scope="col">المبلغ</th>
              <th scope="col">الملاحظات </th>
              <th scope="col"> المستخدم </th>
              <th scope="col">التاريخ</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas7" :key="f.id">
              <th scope="row">{{ f.client ? f.client.name : '' }}</th>
              <td>{{ f.money }}</td>
              <td>{{ f.note }}</td>
              <td>{{ f.user ? f.user.name : '' }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
             
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BranchSalesReportAllDetail } from "../../config/apiRoute.js";
import { appUrl } from "../../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],
      fatworas2: [],
      fatworas3: [],
      fatworas4: [],
      fatworas5: [],
      fatworas6: [],
      fatworas7: [],
      fatworas_sum: 0,
      fatworas2_sum: 0,
      fatworas3_sum: 0,
      fatworas4_sum: 0,
      fatworas5_sum: 0,
      fatworas6_sum: 0,
      fatworas7_sum: 0,
      appUrl: "" 
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("branch_id", this.$route.query.id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      BranchSalesReportAllDetail(frmData).then(response => {
     response.data.fatworas.length > 0
          ? (this.fatworas = response.data.fatworas)
          : (this.fatworas = []);
        response.data.fatworas2.length > 0
          ? (this.fatworas2 = response.data.fatworas2)
          : (this.fatworas2 = []);
        response.data.fatworas3.length > 0
          ? (this.fatworas3 = response.data.fatworas3)
          : (this.fatworas3 = []);
        response.data.fatworas4.length > 0
          ? (this.fatworas4 = response.data.fatworas4)
          : (this.fatworas4 = []);
        response.data.fatworas5.length > 0
          ? (this.fatworas5 = response.data.fatworas5)
          : (this.fatworas5 = []);
        response.data.fatworas6.length > 0
          ? (this.fatworas6 = response.data.fatworas6)
          : (this.fatworas6 = []);
        response.data.fatworas7.length > 0
          ? (this.fatworas7 = response.data.fatworas7)
          : (this.fatworas7 = []);
        this.fatworas_sum = response.data.fatworas_sum;
        this.fatworas2_sum = response.data.fatworas2_sum;
        this.fatworas3_sum = response.data.fatworas3_sum;
        this.fatworas4_sum = response.data.fatworas4_sum;
        this.fatworas5_sum = response.data.fatworas5_sum;
        this.fatworas6_sum = response.data.fatworas6_sum;
        this.fatworas7_sum = response.data.fatworas7_sum;
       
        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
